import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/video_popularize_award",
  name: "video_popularize_award",
  component: function component() {
    return import("../../../views/video_popularize_award/index.vue");
  },
  meta: {
    foot: true
  }
}, {
  path: "/video_popularize_award_details/:id?",
  name: "video_popularize_award_details",
  component: function component() {
    return import("../../../views/video_popularize_award/details.vue");
  },
  meta: {
    foot: true,
    title: "推广权限"
  }
}];